import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 3.94 15.46' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M.54 3.29A1.87 1.87 0 0 1 0 1.89 1.81 1.81 0 0 1 .54.52 2 2 0 0 1 2 0a2 2 0 0 1 1.4.52 1.81 1.81 0 0 1 .54 1.37 1.87 1.87 0 0 1-.54 1.4 2 2 0 0 1-1.4.53 2 2 0 0 1-1.46-.53zM.4 15.36a.36.36 0 0 1-.1-.26V5.43a.35.35 0 0 1 .36-.36h2.62a.34.34 0 0 1 .36.36v9.67a.34.34 0 0 1-.36.36H.66a.35.35 0 0 1-.26-.1z'
        fill='#f3f3f3'
        data-name='general content'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/InfoIcon.js